import { useEffect, useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import {
  alertRouteItems,
  analyticsRouteItems,
  dashboardRoute,
  passportRoute,
  resultsRoute,
  settingsRoutes,
  studentsRoute,
  testSettingsItems
} from '../../routes';

const FAVICON_URL = 'https://psixologiya.suvoriy.com/kutubxona/images/favicon.png';
const DEFAULT_TITLE = 'Psixologiya';

const CUSTOM_ROUTES = [
  { path: '/psixologik-pasport/view', title: 'Talaba pasporti' },
  { path: '/patients', title: 'Bemorlar' },
  { path: '/services', title: 'Xizmatlar' },
  { path: '/payments', title: "To'lovlar" },
  { path: '/doctors', title: 'Shifokorlar' },
  { path: '/uzd', title: 'UTT' },
  { path: '/laboratory', title: 'Laboratoriya' },
  { path: '/reports', title: 'Hisobotlar' },
  { path: '/expenses', title: 'Xarajatlar' },
  { path: '/staff', title: 'Xodimlar' },
  { path: '/attendance', title: 'Davomat' },
  { path: '/roles', title: 'Rollar' },
  { path: '/filials', title: 'Filiallar' },
  { path: '/analysis-document', title: 'Tahlil hujjati' },
  { path: '/test-sozlamalari/biriktirish', title: 'Test biriktirish' },
  { path: '/test-sozlamalari/davr', title: 'Yil va chorak' },
  { path: '/pages/profile', title: 'Profil' },
  { path: '/pages/notifications', title: 'Bildirishnomalar' },
  { path: '/authentication/basic', title: 'Kirish' },
  { path: '/authentication/basic/login', title: 'Kirish' },
  { path: '/authentication/basic/student-test', title: 'Talaba testi' },
  { path: '/authentication/basic/student-passport', title: 'Talaba pasporti' },
  { path: '/authentication/basic/logout', title: 'Chiqish' },
  { path: '/errors/404', title: 'Sahifa topilmadi' },
  { path: '/errors/500', title: 'Server xatosi' }
];

const collectRouteTitles = items =>
  items.reduce((accumulator, item) => {
    const current = item.to && item.name ? [{ path: item.to, title: item.name }] : [];
    const children = Array.isArray(item.children) ? collectRouteTitles(item.children) : [];
    return accumulator.concat(current, children);
  }, []);

const ensureLinkHref = (rel, href) => {
  let link = document.querySelector(`link[rel="${rel}"]`);

  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', rel);
    document.head.appendChild(link);
  }

  link.setAttribute('href', href);
};

const resolveTitle = (pathname, routes) => {
  const matchedRoute = routes.find(route =>
    matchPath(pathname, {
      path: route.path,
      exact: route.path === '/',
      strict: false
    })
  );

  return matchedRoute ? matchedRoute.title : DEFAULT_TITLE;
};

const PageMetaManager = () => {
  const location = useLocation();

  const routeTitles = useMemo(() => {
    const namedRoutes = collectRouteTitles([
      dashboardRoute,
      studentsRoute,
      passportRoute,
      resultsRoute,
      settingsRoutes,
      ...analyticsRouteItems,
      ...alertRouteItems,
      ...testSettingsItems
    ]);

    return [...namedRoutes, ...CUSTOM_ROUTES].sort((left, right) => right.path.length - left.path.length);
  }, []);

  useEffect(() => {
    document.title = resolveTitle(location.pathname, routeTitles);
    ensureLinkHref('icon', FAVICON_URL);
    ensureLinkHref('shortcut icon', FAVICON_URL);
  }, [location.pathname, routeTitles]);

  return null;
};

export default PageMetaManager;
